export default {
    small: `(min-width: 512px)`,
    medium: `(min-width: 768px)`,
    large: `(min-width: 1024px)`,
    content: `(min-width: 1200px)`,
    laptop: `(min-width: 1440px)`,
    desktop: `(min-width: 1920px)`
}